const dateTime = {
  dateFormat: 'YYYY/MM/DD',
}
export default dateTime
